import Icon from '../components/Icon.vue'

Icon.register({
  save: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M433.9 129.9c7.8 7.8 14.1 23 14.1 33.9v268.1c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h268.1c11 0 26.2 6.3 33.9 14.1zM224 416c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM320 111.5c0-2.7-1.6-6.5-3.5-8.5l-3.5-3.5c-2.3-2.3-5.3-3.5-8.5-3.5h-228.5c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h232c6.6 0 12-5.4 12-12v-100.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/save.js
// module id = 1862
// module chunks = 0